import { render, staticRenderFns, recyclableRender, components } from "./mescroll-empty.vue?vue&type=template&id=bf24a008&scoped=true&"
var renderjs
import script from "./mescroll-empty.vue?vue&type=script&lang=js&"
export * from "./mescroll-empty.vue?vue&type=script&lang=js&"
import style0 from "./mescroll-empty.vue?vue&type=style&index=0&id=bf24a008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24a008",
  null,
  false,
  components,
  renderjs
)

export default component.exports